import PlanFeatures from '@anm/components/pricing/PlanFeatures';
import PlanPeriodButtonBlock, { PlanPeriodButtonBlockProps } from '@anm/components/pricing/PlanPeriodButtonBlock';
import { PricingTablePlan } from '@anm/components/pricing/PricingTable/types';
import { media } from '@anm/styles/helpers';
import noop from 'lodash/fp/noop';
import { useCallback, FC } from 'react';
import styled from 'styled-components';

export type PricingColumnProps = PricingTablePlan &
  Pick<PlanPeriodButtonBlockProps, 'siblingDropdownOptions' | 'sibling' | 'onSiblingChange' | 'disabled'>;

const wrapperResponsive = media.desktop_small`
    padding: 0 30px 40px 18px;
`;

const wrapperTablet = media.tablet`
    padding: 34px 40px 40px 40px;
    border: 0 none;
    border-bottom: 1px solid #EBEEF5;
    flex-basis: auto;
`;

const mediumMobile = media.phone`
    margin-bottom: 20px;
`;

const Top = styled.div`
  position: relative;
  margin-bottom: 20px;
`;
const Medium = styled.div`
  margin-bottom: 46px;
  ${mediumMobile};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 60px 40px 40px;
  border-right: 1px solid #ebeef5;
  position: relative;
  &:last-of-type {
    border-right: 0 none;
  }
  ${wrapperResponsive};
  ${wrapperTablet};
`;

const PricingColumn: FC<PricingColumnProps> = ({
  id,
  price,
  variant,
  planName,
  features,
  isAnnual,
  discount,
  periodName,
  sibling,
  siblingDropdownOptions,
  isSamePlan,
  isSamePeriod,
  description,
  showPlanTopButton,
  disabled,
  onGetPlanClick = noop,
  onSiblingChange
}) => {
  const handleGetPlanClick = useCallback(() => {
    onGetPlanClick(id);
  }, []);

  return (
    <Wrapper>
      <Top>
        <PlanPeriodButtonBlock
          {...{
            price,
            variant,
            sibling,
            isAnnual,
            planName,
            discount,
            disabled,
            periodName,
            isSamePlan,
            description,
            isSamePeriod,
            ...(sibling && { siblingDropdownOptions, onSiblingChange })
          }}
          showPlanButton={showPlanTopButton}
          onGetPlanClick={handleGetPlanClick}
        />
      </Top>
      <Medium>
        {features.map(({ title, features }) => (
          <PlanFeatures title={title} list={features} />
        ))}
      </Medium>
    </Wrapper>
  );
};

export default PricingColumn;
